import Image from 'next/future/image';
import cn from 'classnames';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const Default = ({
  isHealthBeautyCollection,
}: {
  isHealthBeautyCollection: boolean;
}) => {
  // Handle Banner Images
  const getBannerImage = () => {
    if (isHealthBeautyCollection)
      return getEdgeUrl('images/collections/banner/default/health_beauty.png');

    return getEdgeUrl('images/collections/banner/default/phones.png');
  };

  const bannerImage = getBannerImage();

  return (
    <div
      className={cn(
        'absolute bottom-0 w-[130px] md:w-[125px] lg:w-[140px] xl:w-[160px]',
        {
          'right-0': isHealthBeautyCollection,
          'right-3 xs:right-[-50px] sm:right-[-20px] md:right-[-10px] lg:right-3':
            !isHealthBeautyCollection,
        },
      )}
    >
      <Image
        src={bannerImage}
        alt="phones"
        loading="eager"
        className="h-auto w-full rounded-r-md object-cover object-left opacity-20 xs:opacity-100 lg:rounded-none"
        width={292}
        height={206}
      />
    </div>
  );
};

export default Default;
